// src/config/Lc.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { createContext } from 'react';

// *******************************************************************************
// CONTEXT
// *******************************************************************************
// languageContextReload that holds a version number that increments whenever language changes
// Components can subscribe to this to re-render when translations update
export const languageContextReload = createContext(0);
